// 散点图-火山图
import ChartTemplate from '../ChartTemplate';
import { paramConvert } from '@/plugins/chart';
import { SVG } from '@svgdotjs/svg.js';
import '@svgdotjs/svg.draggable.js';

let lx, ly, xMax, downLabel='DOWN',upLabel='UP',notLabel='unchange';
export default {
  extends: ChartTemplate,
  props: {
    formButtons: {
      default: function () {
        return [{ embed: true, code: 'ss', name: '标记', text: true, click: () => this.onShowSs() }]
      }
    },
    config: {
      default: function () { return { z: -1 } }
    }
  },
  data () {
    return {
      ss: [],
      extCPT: () => import('./ExtendComponent.vue'),
      extCPTValue: false,
      srcSeries: null
    }
  },
  computed: {
    extCPTProps () { return { items: this.ss } }
  },
  methods: {
    initDataAfter () {
      if (this.config.xlog != false || this.config.ylog != false) {
        this.dataSource.slice(1).forEach(row => {
          if (this.config.xlog != false) row[1] = Math.log2(row[1]);
          if (this.config.ylog != false) row[2] = -Math.log10(row[2]);
        })
      }
      xMax = Math.abs(this.dataSource[1][1]);
      this.dataSource.slice(2).forEach(row => {
        let tm = Math.abs(row[1]);
        if (tm > xMax) xMax = tm;
      })
      xMax = parseInt(xMax);
    },
    initParamAfter () {
      let xv = this.paramFormData.volcano_control || 2;
      let yv = this.paramFormData.volcano_pvalue || 0.05;
      lx = Math.log2(xv);
      ly = -Math.log10(yv);
      this.initGroup();
    },

    initOptionAfter () {
      let option = {
        plotOptions: { series: { marker: { symbol: 'circle', radius: 2 }, point: { events: { click: this.pointClick } } } },
        xAxis: { min: -xMax, max: xMax, title: { text: 'log2(FC)' } },
        yAxis: { title: { text: '-log10（p-value）' } },
        legend: { enabled: true }
      }
      let series = this.chartOption.series;
      let newSeries = [{ name: downLabel, data: [] }, { name: notLabel, data: [] }, { name: upLabel, data: [] }];
      series.forEach(ss => {
        if (ss.name == downLabel) newSeries[0].data = ss.data;
        else if (ss.name == notLabel) newSeries[1].data = ss.data;
        else newSeries[2].data = ss.data;
      })
      this.chartOption.series = newSeries;
      this.Utility.deepMerge(this.chartOption, option);
      this.srcSeries = this.Utility.clone(this.chartOption.series);
    },
    onParamFormChanged (e, item) {
      this.paramFormData[item.code] = e;
      let r1 = this.onParamFormChangedBefore(e, item);
      if (r1 === false) return;
      let value = paramConvert(item.code, e);
      let option = value;
      if (item.optionCode) option = JSON.parse(item.optionCode.replaceAll('\\${value}', value));
      if (item.code == 'volcano_pvalue') {
        ly = value;
        this.updateGroup(option);
      } else if (item.code == 'volcano_control') {
        lx = value;
        this.updateGroup(option);
      } else {
        this.chart.update(option);
      }
      this.onParamFormChangedAfter(value, item);
    },
    // 初始化分组
    initGroup () {
      this.dataSource[0].unshift('group');
      this.dataSource.slice(1).forEach(d => {
        if (d[1] < -lx && d[2] > ly) d.unshift(downLabel);
        else if (d[1] > lx && d[2] > ly) d.unshift(upLabel);
        else d.unshift(notLabel);
      })
    },
    // 更新分组
    updateGroup (option) {
      let s1 = this.srcSeries[0].name, s2 = this.srcSeries[1].name, s3 = this.srcSeries[2].name;
      let newSeries = [{ name: s1, data: [] }, { name: s2, data: [] }, { name: s3, data: [] }];
      let downIndex = 0, notIndex = 1, upIndex = 2;
      this.srcSeries.forEach(ser => {
        ser.data.forEach(d => {
          if (d.x < -lx && d.y > ly) newSeries[downIndex].data.push(d);
          else if (d.x > lx && d.y > ly) newSeries[upIndex].data.push(d);
          else newSeries[notIndex].data.push(d);
        })
      })
      let newOption = { series: newSeries };
      this.Utility.deepMerge(newOption, option);
      this.chart.update(newOption);
    },



    // ============================ 点标记
    pointClick (e) {
      let point = e.point;
      if (this.ss.indexOf(point) == -1) {
        let dataLabels = { enabled: true, allowOverlap: true, format: '{point.name}', shape: 'callout', borderWidth: 1, borderColor: '#1976D2', x: 50 };
        point.update({ dataLabels: dataLabels });
        this.ss.push(point);
        this.initDataLabelListener(point);
      } else {
        this.ss.splice(this.ss.indexOf(point), 1);
        point.update({ dataLabels: { enabled: false } });
      }
    },
    initDataLabelListener (point) {
      let $g = SVG(point.dataLabel.element); // {g:[path,{text:[tspan,tspan]}]}
      let $text = $g.children()[1];
      $text.plain($text.children()[0].text());
      let $path = $g.children()[0];
      let _bps = $path.array().filter(a => a[0] != 'C');
      let w = Math.abs(_bps[1][1] - _bps[0][1]), h = Math.abs(_bps[2][2] - _bps[1][2]), cx, cy;
      if (_bps.length > 6) cx = _bps[5][1], cy = _bps[5][2];
      else {
        let $point = SVG(point.graphic.element);
        let pcx = $point.cx(), pcy = $point.cy();
        let gTrans = $g.transform();
        cx = Math.abs(pcx - gTrans.translateX), cy = Math.abs(pcy - gTrans.translateY);
      }
      let x1, y1, x, y, textX, textY;
      $text.draggable().on('beforedrag', e => {
        x1 = e.detail.event.x; y1 = e.detail.event.y;
        let ds = $path.array()[0];
        x = ds[1]; y = ds[2];
        textX = e.target.instance.x(); textY = e.target.instance.y();
      }).on('dragmove', e => {
        let x2 = e.detail.event.x, y2 = e.detail.event.y;
        let ex = x2 - x1, ey = y2 - y1;
        let nx = x + ex, ny = y + ey;
        let p1 = { x: nx, y: ny }, p2 = { x: nx + w, y: ny }, p3 = { x: nx + w, y: ny + h }, p4 = { x: nx, y: ny + h };
        let cp1 = { x: p1.x + (p2.x - p1.x) / 2, y: p1.y }, cp2 = { x: p2.x, y: p2.y + (p3.y - p2.y) / 2 }, cp3 = { x: p4.x + (p3.x - p4.x) / 2, y: p3.y }, cp4 = { x: p1.x, y: p1.y + (p4.y - p1.y) / 2 };
        let cpp = { x: cx, y: cy };
        let dis1 = this.getDistance(cpp, cp1), dis2 = this.getDistance(cpp, cp2), dis3 = this.getDistance(cpp, cp3), dis4 = this.getDistance(cpp, cp4);
        let minDis = Math.min(dis1, dis2, dis3, dis4);
        let d;
        if (minDis == dis1) { // 连接矩形的上边
          d = `M ${p1.x} ${p1.y} L ${p1.x + (p2.x - p1.x) / 2} ${p1.y} L ${cx} ${cy} L ${p1.x + (p2.x - p1.x) / 2} ${p1.y} L ${p2.x} ${p2.y} L ${p3.x} ${p3.y} L ${p4.x} ${p4.y} L ${p1.x} ${p1.y}`;
        } else if (minDis == dis2) {  // 连接矩形的右边
          d = `M ${p1.x} ${p1.y} L ${p2.x} ${p2.y} L ${p2.x} ${p2.y + (p3.y - p2.y) / 2} L ${cx} ${cy} L ${p2.x} ${p2.y + (p3.y - p2.y) / 2} L ${p3.x} ${p3.y} L ${p4.x} ${p4.y} L ${p1.x} ${p1.y}`;
        } else if (minDis == dis3) {  // 连接矩形的下边
          d = `M ${p1.x} ${p1.y} L ${p2.x} ${p2.y} L ${p3.x} ${p3.y} L ${p4.x + (p3.x - p4.x) / 2} ${p3.y}  L ${cx} ${cy} L ${p4.x + (p3.x - p4.x) / 2} ${p3.y} L ${p4.x} ${p4.y} L ${p1.x} ${p1.y}`;
        } else if (minDis == dis4) { // 连接矩形的左边
          d = `M ${p1.x} ${p1.y} L ${p2.x} ${p2.y} L ${p3.x} ${p3.y} L ${p4.x} ${p4.y} L ${p1.x} ${p1.y + (p4.y - p1.y) / 2} L ${cx} ${cy} L ${p1.x} ${p1.y + (p4.y - p1.y) / 2} L ${p1.x} ${p1.y}`;
        }
        $path.plot(d);
        e.target.instance.x(textX + ex).y(textY + ey);
      })
    },
    getDistance (p1, p2) {
      let xs = p2.x - p1.x;
      xs = xs * xs;
      let ys = p2.y - p1.y;
      ys = ys * ys;
      return Math.sqrt(xs + ys);
    },
    onShowSs () {
      this.extCPTValue = true;
    },
    onDeleteSs (index) {
      let point = this.ss[index];
      this.ss.splice(index, 1);
      point.update({ dataLabels: { enabled: false } });
    }

  }
}















// // 散点图OPLS-DA
// import ChartTemplate from '../ChartTemplate';
// import { Scatter } from '@/plugins/dc';

// let
//   lx1 = -0.5,
//   lx2 = 0.5,
//   ly = 1.5,
//   c1 = '#3EFF28', // up
//   c2 = '#FF3B28', // down
//   c3 = '#000000'; // not
// export default {
//   extends: ChartTemplate,
//   data () {
//     return {
//       ss: [],
//       chartOptionButtons: [{ code: 'ss', name: '标记', click: this.onShowSs }],
//       ChartExtendComponent: () => import('./ChartExtendComponent.vue'),
//       chartExtendComponentValue: false
//     }
//   },
//   computed: {
//     chartExtendComponentProps () {
//       return {
//         toolTaskId: this.toolTaskId,
//         items: this.ss
//       }
//     }
//   },
//   methods: {
//     async chartDataSourceLoaded () {
//       this.chartOption = Scatter(this.chartDataSource, this.dataSourceParam);
//     },
//     eventValueChangedBefore (item, value) {
//       if (item.optionCode == 'colors') {
//         c1 = value[0];
//         c2 = value[1];
//         c3 = value[2];
//         this.updatePointColor();
//         return false;
//       } else if (item.code == 'volcano_pvalue') {
//         ly = -Math.log10(value);
//         let options = { yAxis: { plotLines: [{ value: ly, color: 'black', dashStyle: 'dot', width: 2 }] } }
//         this.updatePointColor(options);
//         return false;
//       } else if (item.code == 'volcano_control') {
//         lx1 = -Math.log2(value);
//         lx2 = Math.log2(value);
//         let options = { xAxis: { plotLines: [{ value: lx1, color: 'black', dashStyle: 'dot', width: 2 }, { value: lx2, color: 'black', dashStyle: 'dot', width: 2 }] } };
//         this.updatePointColor(options);
//         return false;
//       }
//     },
//     chartDefaultOption () {
//       let xv = this.chartParams.find(item => item.code == 'volcano_control').dftValue;
//       let yv = this.chartParams.find(item => item.code == 'volcano_pvalue').dftValue;
//       lx1 = -Math.log2(xv), lx2 = Math.log2(xv), ly = -Math.log10(yv);
//       return {
//         chart: { animation: false, type: 'scatter' },
//         credits: { enabled: false },
//         plotOptions: { series: { stickyTracking: false }, scatter: { marker: { radius: 2 }, point: { events: { click: this.pointClick } }, turboThreshold: 0 } },
//         title: { text: '' },
//         xAxis: {
//           min: -4, max: 4, title: { text: 'log2(TMT/Control)' },
//           plotLines: [
//             { value: lx1, color: '#000000', dashStyle: 'dot', width: 2, zIndex: 3 },
//             { value: lx2, color: '#000000', dashStyle: 'dot', width: 2, zIndex: 3 }
//           ]
//         },
//         yAxis: {
//           tickWidth: 1, lineWidth: 1, gridLineWidth: 0, title: { text: '-log10(PValue)' },
//           plotLines: [{ value: ly, color: '#000000', dashStyle: 'dot', width: 2, zIndex: 3 }]
//         },
//         legend: { enabled: false },
//         tooltip: { headerFormat: '', pointFormat: '{point.x}, {point.y}' },
//         ...this.chartOption
//       }
//     },

//     chartLoaded () {
//       this.drawRightLenged();
//       this.updatePointColor();
//     },

//     // ===================== 绘制右侧图例
//     drawRightLenged () {
//       let svgNode = this.chart.container.children[0];
//       let bbox = svgNode.getBBox();
//       let g = this.chart.renderer.g('right-legend').add();
//       let x = bbox.width - 80, y = (bbox.height / 2) - 50;
//       this.chart.renderer.rect(x, y, 24, 24, 0).attr({ fill: '#fff', stroke: 'black', 'stroke-width': 2 }).add(g);
//       this.chart.renderer.circle(x + 12, y + 12, 8).attr({ fill: c1 }).add(g);
//       this.chart.renderer.text('UP', x + 30, y + 16).attr({ 'font-size': 12 }).add(g);

//       this.chart.renderer.rect(x, y + 24, 24, 24, 0).attr({ fill: '#fff', stroke: 'black', 'stroke-width': 2 }).add(g);
//       this.chart.renderer.circle(x + 12, y + 12 + 24, 8).attr({ fill: c2 }).add(g);
//       this.chart.renderer.text('DOWN', x + 30, y + 16 + 24).attr({ 'font-size': 12 }).add(g);

//       this.chart.renderer.rect(x, y + 24 * 2, 24, 24, 0).attr({ fill: '#fff', stroke: 'black', 'stroke-width': 2 }).add(g);
//       this.chart.renderer.circle(x + 12, y + 12 + 24 * 2, 8).attr({ fill: c3 }).add(g);
//       this.chart.renderer.text('NOT', x + 30, y + 16 + 24 * 2).attr({ 'font-size': 12 }).add(g);
//     },
//     // ======================== 修改点的颜色
//     updatePointColor (opt) {
//       let data = this.chartOption.series[0].data;
//       data.forEach(d => {
//         if (d.x < lx1 && d.y > ly) d.color = c1;
//         else if (d.x > lx2 && d.y > ly) d.color = c2;
//         else d.color = c3;
//       })
//       let d = { series: { data: data }, ...opt }
//       this.chartUpdate(d);
//       let g = document.querySelector('.highcharts-right-legend');
//       g.children[1].setAttribute('fill', c1);
//       g.children[4].setAttribute('fill', c2);
//       g.children[7].setAttribute('fill', c3);
//       this.ss = [];
//     },

//     // ============================ 点标记
//     pointClick (e) {
//       let point = e.point;
//       if (this.ss.indexOf(point) == -1) {
//         let dataLabels = { enabled: true, shape: 'callout', borderRadius: 3, borderWidth: 1, borderColor: '#1976D2', x: 60, format: '{point.name}' };
//         point.update({ dataLabels: dataLabels });
//         this.ss.push(point);
//       } else {
//         this.ss.splice(this.ss.indexOf(point), 1);
//         point.update({ dataLabels: { enabled: false } });
//       }
//     },
//     onShowSs () {
//       this.chartExtendComponentValue = true;
//     },
//     onDeleteSs (index) {
//       let point = this.ss[index];
//       this.ss.splice(index, 1);
//       point.update({ dataLabels: { enabled: false } });
//     }

//   }
// }